import { AUTHENTICATED_HOME_ROUTE, createFileRoute, redirect } from '@frontend/web/utils/router';

const Home = () => <div />;

export const Route = createFileRoute('/app/')({
  beforeLoad: () => {
    throw redirect({ to: AUTHENTICATED_HOME_ROUTE });
  },
  component: Home,
});
